import { FC, PropsWithChildren } from 'react'
import { useIfMobileL, useIfTablet } from 'src/hooks'

export const TabletAndMobile: FC<PropsWithChildren<any>> = (props) => {
  const isTablet = useIfTablet()
  const isMobileL = useIfMobileL()

  return (isTablet || isMobileL) ? <>{props.children}</> : null
}
